






































import { Component, Vue, Prop } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import List from './radar/List.vue'
import Radar3 from './radar/Radar3.vue'
import Settings from './radar/Settings.vue'
import router from '../router'
import { RadarTabState } from '@/types/domain'

@Component({
  components: {
    Radar3,
    List,
    Settings
  },
  computed: {
    activeTabName () {
      return RadarTabState[this.tab]
    },
    ...mapGetters('blips', [
      'isLoaded'
    ]),
    ...mapGetters('user', [
      'userCanEdit'
    ])
  }
})
export default class Radar extends Vue {
  @Prop({ default: '' })
  radarId: string

  tab = 0

  // computed
  activeTabName: RadarTabState
  isLoaded: boolean
  userCanEdit: boolean

  tabChange (newTab: number) : void {
    // console.log(newTab, this.activeTabName)
    switch (newTab) {
      case 0:
        router.replace({ path: `/@${this.radarId}` })
        break
      case 1:
        router.replace({ path: `/@${this.radarId}/history` })
        break
      case 2:
        router.replace({ path: `/@${this.radarId}/settings` })
        break
    }
  }

  activateTabFromRoute () : void {
    if (this.$route.params.mode === 'history') {
      this.tab = 1
    } else if (this.$route.params.mode === 'settings') {
      this.tab = 2
    }
  }

  locationHashChange () : void {
    this.activateTabFromRoute()
  }

  mounted () : void {
    this.activateTabFromRoute()
    // hack to force vue.js to react to a URL change that is being triggered by the d3 radar elements via <a href>
    window.addEventListener('hashchange', this.locationHashChange)
  }

  beforeDestroy () : void {
    // cleanup hack before leaving the component
    window.removeEventListener('hashchange', this.locationHashChange)
  }
}
